import { render, staticRenderFns } from "./OtroDocumento.vue?vue&type=template&id=6ff0f234&scoped=true"
import script from "./OtroDocumento.vue?vue&type=script&lang=js"
export * from "./OtroDocumento.vue?vue&type=script&lang=js"
import style0 from "./OtroDocumento.vue?vue&type=style&index=0&id=6ff0f234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0f234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff0f234')) {
      api.createRecord('6ff0f234', component.options)
    } else {
      api.reload('6ff0f234', component.options)
    }
    module.hot.accept("./OtroDocumento.vue?vue&type=template&id=6ff0f234&scoped=true", function () {
      api.rerender('6ff0f234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otro-documento/OtroDocumento.vue"
export default component.exports